import {
  FETCH_ROOMLIST_REQUEST,
  FETCH_ROOMLIST_SUCCESS,
  FETCH_ROOMLIST_FAILURE,
} from "./roomListTypes";

const initialState = {
  loading: false,
  roomList: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ROOMLIST_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case FETCH_ROOMLIST_SUCCESS:
      return {
        loading: false,
        roomList: action.payload,
        error: "",
      };
    case FETCH_ROOMLIST_FAILURE:
      return {
        loading: false,
        roomList: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
